export const storageKpiModalTableStructure = [
  {
    group: 'Data',
    columns: [
      {
        name: 'Data',
        id: 'data-data',
        show: true
      }
    ]
  },
  {
    group: 'Empresa',
    columns: [
      {
        name: 'Código',
        id: 'empresa-codigo-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'empresa-nome',
        show: true
      }
    ]
  },
  {
    group: 'CD/Loja',
    columns: [
      {
        name: 'Código',
        id: 'cd-loja-codigo-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'cd-loja-codigo-nome',
        show: true
      }
    ]
  },
  {
    group: 'Produto',
    columns: [
      {
        name: 'Código',
        id: 'produto-codigo-id',
        show: true
      },
      {
        name: 'Material',
        id: 'produto-material-id',
        show: true
      }
      // {
      //   name: 'Status',
      //   id: 'produto-status-id',
      //   show: true
      // },
      // {
      //   name: 'Curva',
      //   id: 'produto-curva-abc-id',
      //   show: true
      // }
    ]
  },
  // {
  //   group: 'Mundo',
  //   columns: [
  //     {
  //       name: 'Nome',
  //       id: 'mundo-nome-id',
  //       show: true
  //     }
  //   ]
  // },
  {
    group: 'Categoria Compacta',
    columns: [
      {
        name: 'Nome',
        id: 'categiria-compacta-nome-id',
        show: true
      }
    ]
  },

  {
    group: 'Categoria',
    columns: [
      {
        name: 'Nome',
        id: 'categiria-nome-id',
        show: true
      }
    ]
  },
  {
    group: 'Sub Categoria',
    columns: [
      {
        name: 'Nome',
        id: 'subcategoria-nome-id',
        show: true
      }
    ]
  },
  {
    group: 'Gerente',
    columns: [
      // {
      //   name: 'Categoria',
      //   id: 'gerente-categoria-id',
      //   show: true
      // },
      {
        name: 'Produto',
        id: 'gerente-produto-id',
        show: true
      }
    ]
  },

  {
    group: 'Status',
    columns: [
      {
        name: 'Nome',
        id: 'status-nome',
        show: true
      }
    ]
  },
  {
    group: 'Curva',
    columns: [
      {
        name: 'Nome',
        id: 'curva-nome',
        show: true
      }
    ]
  },
  {
    group: 'Fornecedor',
    columns: [
      {
        name: 'Código',
        id: 'fornecedor-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'fornecedor-nome',
        show: true
      }
    ]
  },

  {
    group: 'Vendas',
    columns: [
      {
        name: 'CMV 4M',
        id: 'vendas-cmv',
        show: true
      },
      {
        name: 'CMV Real',
        id: 'dcmv-real',
        show: true
      },

      {
        name: 'CMV Projetado',
        id: 'vendas-projetado',
        show: true
      },
      {
        name: 'Custo',
        id: 'vendas-custo',
        show: true
      }
    ]
  },
  {
    group: 'Estoque Quantidade',
    columns: [
      {
        name: 'Atual',
        id: 'valor-quantidade-atual-id',
        show: true
      },
      {
        name: 'Trânsito Compra',
        id: 'valor-quantidade-transito-id',
        show: true
      },
      {
        name: 'Trânsito Transferencia',
        id: 'valor-quantidade-transito-trans-id',
        show: true
      },
      {
        name: 'Reservado',
        id: 'valor-quantidade-reservado-id',
        show: true
      },
      {
        name: 'Deposito 16',
        id: 'valor-quantidade-dep16',
        show: true
      },
      {
        name: 'Outros',
        id: 'valor-quantidade-outros',
        show: true
      }
      // {
      //   name: 'Excesso',
      //   id: 'valor-estoque-excesso-id',
      //   show: true
      // },
      // {
      //   name: 'Falta',
      //   id: 'valor-estoque-falta-id',
      //   show: true
      // }
    ]
  },
  {
    group: 'Estoque (R$)',
    columns: [
      {
        name: 'Atual',
        id: 'valor-estoque-atual-id',
        show: true
      },
      {
        name: 'Trânsito Compra',
        id: 'valor-estoque-transito-id',
        show: true
      },
      {
        name: 'Trânsito Transferencia',
        id: 'valor-estoque-transito-trans-id',
        show: true
      },
      {
        name: 'Reservado',
        id: 'valor-estoque-reservado-id',
        show: true
      },
      {
        name: 'Deposito 16',
        id: 'valor-estoque-deposito',
        show: true
      },
      {
        name: 'Outros',
        id: 'valor-estoque-outros',
        show: true
      }
    ]
  },
  {
    group: 'Estoque Dias',
    columns: [
      {
        name: 'Atual',
        id: 'dias-estoque-atual-id',
        show: true
      },
      {
        name: 'Trânsito Compra',
        id: 'dias-estoque-transito-id',
        show: true
      },
      {
        name: 'Trânsito Transferencia',
        id: 'dias-estoque-transito-trans-id',
        show: true
      },
      {
        name: 'Total',
        id: 'dias-estoque-total',
        show: true
      }
    ]
  },

  // {
  //   group: 'Ruptura 0 Dias',
  //   columns: [
  //     {
  //       name: 'Num SKUs-Centros',
  //       id: 'ruptura-num-sku-id',
  //       show: true
  //     },
  //     {
  //       name: 'Ruptura (%)',
  //       id: 'ruptura-porcentagem-id',
  //       show: true
  //     }
  //   ]
  // },
  {
    group: 'Sortimento',
    columns: [
      {
        name: 'Posição',
        id: 'sortimento-posicao',
        show: true
      },
      {
        name: 'Ruptura',
        id: 'sortimento-ruptura',
        show: true
      }
    ]
  }
]
